import { UiKitColor } from '@core/ui';

export const SECONDARY_BACKROUND_COLOR_MAP: Partial<
  Record<UiKitColor, UiKitColor>
> = {
  yellow400: 'yellow100',
  periwinkle200: 'periwinkle100',
};
